var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app',[_c('WebHeader',{attrs:{"currentStateHeaderName":_vm.currentRouteHeaderName,"currentState":_vm.currentRouteName}}),_c('v-main',[_c('v-container',[_c('router-view',{key:_vm.$route.path})],1)],1),_c('WebFooter')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }